module.exports = __webpack_public_path__ + "top-mobile-banner-image.8b12a7cc4c7bd8341f931ee75143e027.png";